<div class="location-picker" data-testid="location-picker">
  <!-- Fallback step 1, and the only place the browser is ever asked for a position: a prompt
       without a click gets dismissed, and a dismissed prompt is blocked for the origin. -->
  <button
    type="button"
    class="btn btn-primary btn-sm w-100"
    (click)="useDevicePosition()"
    [disabled]="deviceBusy"
    data-testid="location-use-device-button"
  >
    @if (deviceBusy) {
      <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
    } @else {
      <fa-icon [icon]="faLocationArrow" class="me-1"></fa-icon>
    }
    <span i18n="@@location.useDevice">Meinen Standort verwenden</span>
  </button>
  @if (deviceHint) {
    <p class="small text-muted mt-2 mb-0" role="status" data-testid="location-device-hint">{{ deviceHint }}</p>
  }

  <p class="small text-muted my-2" i18n="@@location.orEnterPlace">oder Ort eingeben:</p>

  <!-- Fallback step 3: the manual entry. Enter in either field submits, like the button. -->
  <form [formGroup]="form" (ngSubmit)="submitPlace()" novalidate data-testid="location-place-form">
    <div class="d-flex gap-2">
      <label class="visually-hidden" for="location-postal-code" i18n="@@location.postalCode">PLZ</label>
      <input
        id="location-postal-code"
        class="form-control form-control-sm location-postal-code"
        formControlName="postalCode"
        i18n-placeholder="@@location.postalCode"
        placeholder="PLZ"
        autocomplete="postal-code"
        inputmode="numeric"
        data-testid="location-postal-code-input"
      />
      <label class="visually-hidden" for="location-city" i18n="@@location.city">Ort</label>
      <input
        id="location-city"
        class="form-control form-control-sm"
        formControlName="city"
        i18n-placeholder="@@location.city"
        placeholder="Ort"
        autocomplete="address-level2"
        data-testid="location-city-input"
      />
      <button
        type="submit"
        class="btn btn-outline-secondary btn-sm text-nowrap"
        [disabled]="placeBusy || form.invalid"
        data-testid="location-place-submit-button"
      >
        @if (placeBusy) {
          <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
        }
        <span i18n="@@location.apply">Übernehmen</span>
      </button>
    </div>
    @if (placeHint) {
      <p class="small text-danger mt-2 mb-0" role="alert" data-testid="location-place-hint">{{ placeHint }}</p>
    }
  </form>

  @if (locationService.location$ | async) {
    <button type="button" class="btn btn-link btn-sm px-0 mt-2" (click)="clear()" data-testid="location-clear-button" i18n="@@location.clear">
      Standort entfernen
    </button>
  }
</div>
